import { render, staticRenderFns } from "./SortBody.vue?vue&type=template&id=6e86ed1f&scoped=true&"
import script from "./SortBody.vue?vue&type=script&lang=js&"
export * from "./SortBody.vue?vue&type=script&lang=js&"
import style0 from "./SortBody.vue?vue&type=style&index=0&id=6e86ed1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e86ed1f",
  null
  
)

export default component.exports